<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('printerMachine.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="printerMachineInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input
                  v-model="printerMachineInfo.conditions.machineCode"
                  :placeholder="$t('printerMachine.machineCodePlaceholder')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryPrinterMachineMethod">
                  {{ $t('printerMachine.query') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('printerMachine.printerDevice') }}</div>
            <el-button
              v-if="printerMachineInfo.conditions.shopId"
              type="primary"
              size="small"
              @click="_openAddPrinterMachineModal"
              style="float: right;"
            >
              {{ $t('printerMachine.add') }}
            </el-button>
          </div>
          <el-table
            :data="printerMachineInfo.shopPrinterMachines"
            border
            style="width: 100%"
          >
            <el-table-column prop="machineId" :label="$t('printerMachine.id')" align="center"></el-table-column>
            <el-table-column prop="machineCode" :label="$t('printerMachine.machineCode')" align="center"></el-table-column>
            <el-table-column prop="machineType" :label="$t('printerMachine.machineType')" align="center"></el-table-column>
            <el-table-column prop="appId" :label="$t('printerMachine.appId')" align="center"></el-table-column>
            <el-table-column prop="appSecure" :label="$t('printerMachine.appSecure')" align="center"></el-table-column>
            <el-table-column prop="shopName" :label="$t('printerMachine.shop')" align="center"></el-table-column>
            <el-table-column prop="machineImpl" :label="$t('printerMachine.machineImpl')" align="center"></el-table-column>
            <el-table-column prop="createTime" :label="$t('printerMachine.createTime')" align="center"></el-table-column>
            <el-table-column :label="$t('printerMachine.operation')" align="center" width="200">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    @click="_openEditPrinterMachineModel(scope.row)"
                  >
                    {{ $t('printerMachine.edit') }}
                  </el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="_openDeletePrinterMachineModel(scope.row)"
                  >
                    {{ $t('printerMachine.delete') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="printerMachineInfo.conditions.page"
            :page-size="printerMachineInfo.conditions.row"
            :total="printerMachineInfo.total"
            layout="total, prev, pager, next"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-printer-machine ref="addPrinterMachine" @refresh="_queryPrinterMachineMethod"></add-printer-machine>
    <edit-printer-machine ref="editPrinterMachine" @refresh="_queryPrinterMachineMethod"></edit-printer-machine>
    <delete-printer-machine ref="deletePrinterMachine" @refresh="_queryPrinterMachineMethod"></delete-printer-machine>
  </div>
</template>

<script>
import { listShopPrinterMachine } from '@/api/shop/printerMachineApi'
import AdminShop from '@/components/shop/adminShop'
import AddPrinterMachine from '@/components/shop/addPrinterMachine/addPrinterMachine'
import EditPrinterMachine from '@/components/shop/editPrinterMachine/editPrinterMachine'
import DeletePrinterMachine from '@/components/shop/deletePrinterMachine/deletePrinterMachine'

export default {
  name: 'PrinterMachine',
  components: {
    AdminShop,
    AddPrinterMachine,
    EditPrinterMachine,
    DeletePrinterMachine
  },
  data() {
    return {
      printerMachineInfo: {
        shopPrinterMachines: [],
        total: 0,
        records: 1,
        conditions: {
          page: 1,
          row: 10,
          machineCode: '',
          machineType: '',
          shopId: ''
        }
      }
    }
  },
  created() {
    this._listPrinterMachines(1, 10)
  },
  methods: {
    handleShopChange(shop) {
      this.printerMachineInfo.conditions.shopId = shop.shopId
      this._listPrinterMachines(1, 10)
    },
    handleCurrentChange(val) {
      this._listPrinterMachines(val, this.printerMachineInfo.conditions.row)
    },
    async _listPrinterMachines(page, rows) {
      this.printerMachineInfo.conditions.page = page
      this.printerMachineInfo.conditions.row = rows
      try {
        const res = await listShopPrinterMachine(this.printerMachineInfo.conditions)
        this.printerMachineInfo.total = res.total
        this.printerMachineInfo.records = res.records
        this.printerMachineInfo.shopPrinterMachines = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddPrinterMachineModal() {
      this.$refs.addPrinterMachine.open({
        shopId: this.printerMachineInfo.conditions.shopId
      })
    },
    _openEditPrinterMachineModel(row) {
      this.$refs.editPrinterMachine.open(row)
    },
    _openDeletePrinterMachineModel(row) {
      this.$refs.deletePrinterMachine.open(row)
    },
    _queryPrinterMachineMethod() {
      this._listPrinterMachines(1, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}
.filter-container {
  padding-bottom: 10px;
}
</style>